var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BulkActionMenu',{attrs:{"actions":_vm.actions},scopedSlots:_vm._u([{key:"delete",fn:function(ref){
var hide = ref.hide;
return [_c('Delete',{attrs:{"module-name":"quantity","handle-delete-items":_vm.bulkDelete},on:{"trigger":hide}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }